import { BunchModel } from './bunch.model';
import { CameraModel } from './camera.model';
export class CameraTreeModel{
listCamera: CameraModel[];
listBunch: BunchModel[];
}